module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.servicesList,
      "label": "Select products",
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "return-object": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.category.name) + "\n              ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.category.name) + "\n              ")]
      }
    }]),
    model: {
      value: (_vm.selectedServices),
      callback: function($$v) {
        _vm.selectedServices = $$v
      },
      expression: "selectedServices"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.selectedServices), function(service, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "xs12": "",
        "align-center": "",
        "justify-space-between": ""
      }
    }, [_c('v-layout', [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_vm._v("\n                " + _vm._s(service.name) + " in quantity\n              ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "type": "number"
      },
      model: {
        value: (service.amount),
        callback: function($$v) {
          _vm.$set(service, "amount", $$v)
        },
        expression: "service.amount"
      }
    })], 1)], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1948aa42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/AttachServicesToCaseButton.vue
// module id = 964
// module chunks = 1